import { LambdaSchema } from "./types";
import mergeAudioSchema from "./MergeAudioChunksFunction";
import icd10v2Schema from "./ICD10_v2";
import uploadConversationSchema from "./UploadConversationFunction";
import runTranscriptionSchema from "./RunTranscriptionFunction";
import runChatgptSchema from "./RunChatgptFunction";
import runWhisperXDiarizationSchema from "./RunKnowtexWhisperXDiarizationFunction";
import runOrdersV2Schema from "./RunOrdersV2Function";
import runMacrosSchema from "./RunMacrosFunction";
import runEvaluationManagementSchema from "./RunEvaluationManagementFunction";
import runUpdateDiarizationResultsSchema from "./RunUpdateDiarizationResultsFunction";
import mobileAudioProcessorSchema from "./MobileAudioProcessorFunction";

const schemas: Record<string, LambdaSchema> = {
  MergeAudioChunksFunction: mergeAudioSchema,
  ICD10_v2: icd10v2Schema,
  UploadConversationFunction: uploadConversationSchema,
  RunTranscriptionFunction: runTranscriptionSchema,
  RunChatgptFunction: runChatgptSchema,
  RunKnowtexWhisperXDiarizationFunction: runWhisperXDiarizationSchema,
  RunOrdersV2Function: runOrdersV2Schema,
  RunMacrosFunction: runMacrosSchema,
  RunEvaluationManagementFunction: runEvaluationManagementSchema,
  RunUpdateDiarizationResultsFunction: runUpdateDiarizationResultsSchema,
  MobileAudioProcessorFunction: mobileAudioProcessorSchema,
};

export function getLambdaSchema(name: string): LambdaSchema | undefined {
  return schemas[name];
}

